import { FONT_SIZE, FONT_WEIGHT, FONT_PRIMARY } from 'ui-component-library/typo';
import { SPACE } from 'ui-component-library/spacing';
import {
  COLOR_BLUE,
  COLOR_DARK_BLUE,
  COLOR_LIGHT_BLUE,
  COLOR_ORANGE,
  COLOR_DARK_ORANGE,
  COLOR_RED,
  COLOR_GREEN,
  COLOR_DARK_GREEN,
  COLOR_BLACK,
  COLOR_GRAY,
  COLOR_DARK_GRAY,
  COLOR_LIGHT_GRAY,
  COLOR_WHITE,
} from 'ui-component-library/colors';

/**
 * Theme configuration
 */
const theme = {
  /**
   * Palette definition
   * Example usage: theme.palette.darkblue[100] where index is opacity
   */
  palette: {
    blue: {
      100: COLOR_BLUE.opacity100,
      75: COLOR_BLUE.opacity75,
      50: COLOR_BLUE.opacity50,
      25: COLOR_BLUE.opacity25,
    },
    darkBlue: {
      100: COLOR_DARK_BLUE.opacity100,
      75: COLOR_DARK_BLUE.opacity75,
      50: COLOR_DARK_BLUE.opacity50,
      25: COLOR_DARK_BLUE.opacity25,
    },
    lightBlue: {
      100: COLOR_LIGHT_BLUE.opacity100,
      75: COLOR_LIGHT_BLUE.opacity75,
      50: COLOR_LIGHT_BLUE.opacity50,
      25: COLOR_LIGHT_BLUE.opacity25,
    },
    orange: {
      100: COLOR_ORANGE.opacity100,
      75: COLOR_ORANGE.opacity75,
      50: COLOR_ORANGE.opacity50,
      25: COLOR_ORANGE.opacity25,
    },
    darkOrange: {
      100: COLOR_DARK_ORANGE.opacity100,
      75: COLOR_DARK_ORANGE.opacity75,
      50: COLOR_DARK_ORANGE.opacity50,
      25: COLOR_DARK_ORANGE.opacity25,
    },
    red: {
      100: COLOR_RED.opacity100,
      75: COLOR_RED.opacity75,
      50: COLOR_RED.opacity50,
      25: COLOR_RED.opacity25,
    },
    green: {
      100: COLOR_GREEN.opacity100,
      75: COLOR_GREEN.opacity75,
      50: COLOR_GREEN.opacity50,
      25: COLOR_GREEN.opacity25,
    },
    darkGreen: {
      100: COLOR_DARK_GREEN.opacity100,
    },
    black: {
      100: COLOR_BLACK.opacity100,
      75: COLOR_BLACK.opacity75,
      50: COLOR_BLACK.opacity50,
      25: COLOR_BLACK.opacity25,
    },
    gray: {
      100: COLOR_GRAY.opacity100,
      75: COLOR_GRAY.opacity75,
      50: COLOR_GRAY.opacity50,
      25: COLOR_GRAY.opacity25,
    },
    darkGray: {
      100: COLOR_DARK_GRAY.opacity100,
      75: COLOR_DARK_GRAY.opacity75,
      50: COLOR_DARK_GRAY.opacity50,
      25: COLOR_DARK_GRAY.opacity25,
    },
    lightGray: {
      100: COLOR_LIGHT_GRAY.opacity100,
      75: COLOR_LIGHT_GRAY.opacity75,
      50: COLOR_LIGHT_GRAY.opacity50,
      25: COLOR_LIGHT_GRAY.opacity25,
    },
    white: COLOR_WHITE,
    custom: {
      gray: '#F1F4F5',
      lightGray: '#F6F8F9',
      actionBtnHover: '#C9D0D4',
      formHeader: '#383847',
      lightRed: '#FBE7E7',
      navButtonActive: '#3986CE',
      expand: '#F0F3F4',
      headerLightBlue: '#EEF8FF',
      resolvedYellow: '#FED054',
      teal: '#08C5D1',
    },
  },
  /**
   * Typography definition
   * Usage examples: theme.typography.sizes.paragraph
   *                 theme.typography.weight.regular
   */
  typography: {
    sizes: {
      paragraph: FONT_SIZE.PARAGRAPH,
      base: FONT_SIZE.BASE,
      h3: FONT_SIZE.H3,
      h2: FONT_SIZE.H2,
      h1: FONT_SIZE.H1,
      small: FONT_SIZE.S,
      medium: FONT_SIZE.M,
      extraLarge: FONT_SIZE.XL,
    },
    weight: {
      regular: FONT_WEIGHT.REGULAR,
      medium: FONT_WEIGHT.MEDIUM,
      semiBold: FONT_WEIGHT.SEMI_BOLD,
      bold: FONT_WEIGHT.BOLD,
    },
    fonts: {
      default: FONT_PRIMARY,
    },
  },
  /**
   * Spacing definition
   * Usage example: theme.spacing(1) where the param is the magnitude of the spacing
   * Acceptable values: 5,8,10,12,15,20,30
   * @param {number} size - Magnitude of spacing
   * @return {string} - corresponding spacing value
   */
  spacing: (size) => {
    switch (size) {
      case 5:
        return SPACE.S5;
      case 8:
        return SPACE.S8;
      case 10:
        return SPACE.S10;
      case 12:
        return SPACE.S12;
      case 15:
        return SPACE.S15;
      case 20:
        return SPACE.S20;
      case 30:
        return SPACE.S30;
      default:
        return SPACE.S5;
    }
  },
};

export default theme;
